import Vue from 'vue'

Vue.mixin({
	beforeCreate() {
		this.$ssr = this.$options.ssr || this.$root.$options.ssr
		this.$window = this.$options.window || this.$root.$options.window
	},
})
